import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { changeLayout, changeTopbarTheme, toggleRightSidebar, changeLayoutWidth } from "../../store/actions";

// Other Layout related Component
import Navbar from "./Navbar";
import Header from "./Header";
import Footer from "./Footer";
import Rightbar from "../CommonForBoth/Rightbar";
import { popUpConfirm, removeActionablePopUp, removeToastMessage } from "../../store/dbFilter/actions";
import ToastMessage from "../../pages/Utility/ToastMessage";
import ActionablePopUp from "../../pages/Utility/ActionablePopUp";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpened: false,
    };
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this);
  }

  /**
   * Open/close right sidebar
   */
  toggleRightSidebar() {
    this.props.toggleRightSidebar();
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.isPreloader === true) {
        document.getElementById("preloader").style.display = "block";
        document.getElementById("status").style.display = "block";

        setTimeout(function () {
          document.getElementById("preloader").style.display = "none";
          document.getElementById("status").style.display = "none";
        }, 2500);
      } else {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }
    }
  }

  componentDidMount() {
    // Scrollto 0,0
    window.scrollTo(0, 0);

    const title = this.props.location.pathname;
    let currentage = title.charAt(1).toUpperCase() + title.slice(2);

    document.title = currentage + " | iqlabs.io - CSMS";

    this.props.changeLayout("horizontal");
    if (this.props.topbarTheme) {
      this.props.changeTopbarTheme(this.props.topbarTheme);
    }
    if (this.props.layoutWidth) {
      this.props.changeLayoutWidth(this.props.layoutWidth);
    }
    if (this.props.showRightSidebar) {
      this.toggleRightSidebar();
    }
  }

  /**
   * Opens the menu - mobile
   */
  openMenu = (e) => {
    this.setState({ isMenuOpened: !this.state.isMenuOpened });
  };
  render() {
    return (
      <React.Fragment>
        <div id="preloader">
          <div id="status">
            <div className="spinner">
              <i className="ri-loader-line spin-icon"></i>
            </div>
          </div>
        </div>

        <div id="layout-wrapper">
          <Header theme={this.props.topbarTheme} isMenuOpened={this.state.isMenuOpened} toggleRightSidebar={this.toggleRightSidebar} openLeftMenuCallBack={this.openMenu} />
          {this.props.toast?.map((toast) => (
            <ToastMessage key={toast.id} toastData={toast} onClose={() => this.props.removeToastMessage(toast.id)} />
          ))}
          <div style={{ ...styles.overlay, display: this.props.popUp?.length > 0 ? "block" : "none" }}>
            {this.props.popUp?.map((item, index) => (
              <ActionablePopUp
                key={item.id}
                popUpData={item}
                index={index}
                onClose={(response) => {
                  if (response) {
                    this.props.popUpConfirm(item.id, item?.popUpType);
                  }
                  this.props.removeActionablePopUp(item.id, response);
                }}
              />
            ))}
          </div>
          <Navbar menuOpen={this.state.isMenuOpened} />
          <div className="main-content">
            {this.props.children}
            <Footer />
          </div>
        </div>
        <Rightbar />
      </React.Fragment>
    );
  }
}

const styles = {
  overlay: {
    position: "fixed",
    height: "100%",
    width: "100%",
    top: "0",
    left: "0",
    backgroundColor: "rgba(0,0,0,0.6)",
    zIndex: "10001",
  },
};
const mapStatetoProps = (state) => {
  const { toast, popUp } = state.sharedData;
  return {
    ...state.Layout,
    toast,
    popUp,
  };
};
export default connect(mapStatetoProps, {
  changeTopbarTheme,
  toggleRightSidebar,
  changeLayout,
  changeLayoutWidth,
  removeToastMessage,
  removeActionablePopUp,
  popUpConfirm,
})(withRouter(Layout));
